import PubNub from "pubnub";
import * as messageActions from "actions/messageActions";
import * as workOrderActions from "actions/workOrderActions";
import * as userActions from "actions/userActions";
import * as statusActions from "actions/statusActions";
import * as transactionLoggingActions from "actions/transactionLoggingActions";
import { toastr } from "react-redux-toastr";
import TokenManager from "accessTokens/TokenManager";
import initialState from "../reducers/initialState";
import log from "utils/logger";
import { getAccessTokenFromState } from 'utils/userManager';
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
// eslint-disable-next-line
import fetch from 'node-fetch';

const apiUrls = require('../constants/apiUrls');
const logger = log("pubnubMiddleware");

let pubNub;
let appianPubNub;

let monitoringInterval = null;

let retriesLeft = 10;
let pubnubErrorShown = false;

export const determineWorkOrderId = (message, store) => {
  const { orderId: messageWorkOrderId } = message;

  // using an old fashioned way of accessing store state cause I just
  // don't give a 'bout testing this crap.
  const activelySelectedWorkOrderId = store.getState().get('site').get('activelySelectedWorkOrderId');

  // In order to maintain the logic, we will select the messages work order id over the selected.
  // IPVE-294: for IPVE equipment, the appian layer does not receive the work order id from Symphonica.
  // This is a work-around in that we don't have time to wait for Symphonica to update their API.
  // We will maintain much of the existing behavior of the code plus this logic until we can get that back-end fixed.
  if (messageWorkOrderId && messageWorkOrderId.length > 0) {
    // this is just a warning for a developer to look at during runtime...
    if (messageWorkOrderId !== activelySelectedWorkOrderId) console.warn(
      'something is wrong -> the actively selected work order id doesn\'t the message work order id\n'
      + 'this indicates that the user may have navigated to another work order while the pubnub message'
      + ' had come in delayed'
    );

    return messageWorkOrderId;
  }

  // when the pub nub message is missing the work order id, then it's likely we're handling a message
  // that is not meant for this code... we can assume the work order id we want is the one set when opening
  // the work order details page.
  return (activelySelectedWorkOrderId || "");
};

const userChannelListener = (payload, user, store) => {

  const userId = user.get("userId");
  const instanceId = user.get("instanceId");
  const timeStamp = new Date();
  const pubNubPayload = payload.message;
  const pubNubMessage = pubNubPayload.message;

  let originalPayload;

  if (pubNubMessage && pubNubMessage.payload) {
    originalPayload = pubNubMessage.payload;

    if (
      pubNubPayload.message &&
      pubNubPayload.message.requestedStatus &&
      pubNubPayload.message.action === "TechStatusUpdate"
    ) {
      toastr.info("Status Update Complete...");
      const status = pubNubMessage.status;

      let success = false;

      if (status === "failed") {
        success = false;
      } else {
        if (originalPayload.error && originalPayload.error.length > 0) {
          success = false;
        } else {
          success = true;
        }
      }

      const payloadUserId = pubNubPayload.userId;

      const timestamp = new Date();
      if (success) {
        store.dispatch(
          statusActions.setTechStatusFinished(
            {
              originalPayload,
              userId,
              timestamp
            },
            payloadUserId
          )
        );
      } else {
        const error = originalPayload.error;

        store.dispatch(
          statusActions.setTechStatusFailed(
            {
              error,
              userId,
              timeStamp
            },
            payloadUserId
          )
        );
      }
    }

    if (
      pubNubPayload.message &&
      pubNubPayload.message.action === "OrderCloseStart" &&
      pubNubPayload.message.orderId
    ) {
      let orderCloseSuceeded = false;
      const originalPayload = pubNubPayload.message.payload;
      const orderId = pubNubPayload.message.orderId;
      const success = pubNubPayload.message.status;

      if (success === "success") {
        if (originalPayload.validationErrors) {
          if (originalPayload.validationErrors.length < 1) {
            orderCloseSuceeded = true;
          } else {
            orderCloseSuceeded = false;
          }
        }
      } else {
        orderCloseSuceeded = false;
      }

      if (orderCloseSuceeded) {
        const payload = originalPayload;
        store.dispatch(
          workOrderActions.orderCloseFinished(
            {
              payload,
              orderId
            },
            userId
          )
        );

        toastr.info("Work Order " + orderId + " Close Complete");
        const channels = [userId];
        store.dispatch(
          statusActions.getTechStatusStarted(
            {
              techStatusChange: {
                userId: userId,
                techStatusWorkOrder: {
                  workOrderNumber: orderId,
                  arrivalTime: null,
                  serviceType: ""
                },
                techStatus: "GetStatus"
              },
              channels: channels
            },
            userId
          )
        );

        store.dispatch(
          workOrderActions.clearWorkOrderDetail(orderId, "orderStatus")
        );
        store.dispatch(
          workOrderActions.workOrderGetTechRouteStarted({
            userId: userId,
            isSelf: true
          })
        );
      } else {
        let displayError = "Unkown Error";

        if (originalPayload && originalPayload.validationErrors && originalPayload.validationErrors.length > 0) {
          displayError = originalPayload.validationErrors[0].message;
          originalPayload.validationErrors.forEach(function (error) {
            toastr.info(error.message);
          });
        } else {
          displayError = "Unknown Error From Api";
          toastr.info(displayError);
        }

        const timeStamp = new Date();
        store.dispatch(
          workOrderActions.orderCloseFailed(
            {
              displayError,
              userId,
              timeStamp
            },
            orderId
          )
        );
      }
    }
  } else {
    if (payload.message && payload.message.WorkOrderUpdateList) {
      toastr.info("Route Updated. Refreshing...");
      const channels = [userId];
      store.dispatch(
        statusActions.getTechStatusStarted(
          {
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: null,
                arrivalTime: null,
                serviceType: ""
              },
              techStatus: "GetStatus"
            },
            channels: channels
          },
          userId
        )
      );

      store.dispatch(
        workOrderActions.workOrderGetTechRouteStarted({
          userId: userId,
          isSelf: true
        })
      );
    }

    if (
      payload &&
      payload.message &&
      payload.message.action &&
      payload.message.action === "Logout" &&
      payload.message.instanceId !== instanceId
    ) {
      store.dispatch(
        statusActions.setTechStatusNotReady(
          {
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: "",
                arrivalTime: ""
              },
              techStatus: "Notready"
            },
            channels: [userId]
          },
          userId
        )
      );
      TokenManager.logout();
    }

    if (
      payload &&
      payload.message &&
      payload.message.action &&
      payload.message.action === "HardReset"
    ) {
      TokenManager.logout();
      store.dispatch({
        type: "persist/REHYDRATE",
        payload: initialState
      });
    }

    if (
      payload &&
      payload.message &&
      payload.message.action &&
      payload.message.action === "SendLogs"
    ) {
      store.dispatch(
        transactionLoggingActions.transactionLogSendStarted(
          store.getState().getIn(["transactionLog", "logs"])
        )
      );
    }

    if (
      payload &&
      payload.message &&
      payload.message.action &&
      payload.message.action === "FstAlert"
    ) {
      const toastrOptions = {
        timeOut: 10000,
        progressBar: false,
        position: "bottom-right"
      };

      toastr.info(
        `${payload.message.fromUser} - ${payload.message.alertMessage}`,
        toastrOptions
      );
    }

    if (
      payload &&
      payload.message &&
      payload.message.action &&
      payload.message.action === "SyncStatus" &&
      payload.message.instanceId !== instanceId
    ) {
      store.dispatch(
        statusActions.getTechStatusStarted(
          {
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: null,
                arrivalTime: null,
                serviceType: ""
              },
              techStatus: "GetStatus"
            },
            channels: [userId]
          },
          userId
        )
      );
      store.dispatch(
        workOrderActions.workOrderGetTechRouteStarted({
          userId: userId,
          isSelf: true
        })
      );
    }
  }
};

export const statusListener = (statusEvent, user, store) => {
  logger.info(statusEvent);

  const state = store.getState();
  const userId = user.get('userId');
  const techId = state.getIn(['techData', 'techs', userId, 'info', 'techId']);
  const accessToken = getAccessTokenFromState(state);
  const messageState = state.get("message");
  const pubNubToken = state.getIn(["techData", "pubNubToken"]);

  if (
    statusEvent.category === "PNAccessDeniedCategory" &&
    accessToken &&
    !messageState.get("userChannelGrantStarted")
  ) {
    if (!pubNubToken) {
      console.log(`PubNub token not found yet. Retrying`);
      store.dispatch(
        messageActions.userChannelGrantStarted(
          user,
          accessToken
        )
      );
    }
    else if (retriesLeft <= 0) {
      console.error('Got PNAccessDeniedCategory event too many times. Will try reconnecting');
      if (!pubnubErrorShown) {
        toastr.warning(
          'There was a problem connecting to the servers.',
          'Status updates and other features will not work',
          {
            timeOut: 10 * 1000,
          }
        );
        pubnubErrorShown = true;
      }
      callPubNubToken(user, techId, store);
    } else {
      store.dispatch(
        messageActions.userChannelGrantStarted(
          user,
          accessToken
        )
      );
      retriesLeft = retriesLeft - 1;
    }
  }
};

const setPresenceData = (store, data) => {
  store.dispatch(userActions.setPresenceData(data));
};

const initAppianPubnub = (techId, user, store) => {
  const state = store.getState();
  if (!user || !techId) {
    const freshUserId = state.getIn(['user', 'userId']);
    user = user || state.getIn(['user']);
    techId = techId || (freshUserId && state.getIn(['techData', 'techs', freshUserId, 'info', 'techId']));
    if (!user || !techId) {
      console.log(`User or Tech ID not found!`);
      return;
    }
  }
  let token = state.getIn(["techData", "pubNubToken"]);

  if (!token) {
    console.log(`Trying to retrieve PubNub token: { techid: ${techId}, token: ${token} }`);
    callPubNubToken(store);
  } else {
    addSubAndListen(token, user, store);
  }
};

const initPubNub = (user, techId, store) => {
  const state = store.getState();
  if (!user || !techId) {
    const freshUserId = state.getIn(['user', 'userId']);
    user = user || state.getIn(['user']);
    techId = techId || (freshUserId && state.getIn(['techData', 'techs', freshUserId, 'info', 'techId']));
    if (!user || !techId) {
      console.log(`User or Tech ID not found!`);
      return;
    }
  }
  let token = state.getIn(["techData", "pubNubToken"]);

  if (!token) {
    console.log(`Trying to retrieve PubNub token: { techid: ${techId}, token: ${token} }`);
    callPubNubToken(store);
  } else {
    // Token already in state (e.g. restored by redux-persist) but pubNub module var is null —
    // call addSubAndListen directly instead of waiting for a new SET_PUBNUB_TOKEN action.
    addSubAndListen(token, user, store);
  }
};

const addSubAndListen = (token, user, store) => {
  if (!token) { return; }

  const userId = user && user.get("userId");
  if (!userId) {
    // OIDC hasn't resolved yet — callPubNubToken will be retried once user is available
    return;
  }

  pubNub = new PubNub({
    subscribeKey: "sub-c-339ad19e-547a-11e7-97ec-0619f8945a4f",
    publishKey: "pub-c-16b7c07d-b174-4cfe-ab08-d1279fe60fdd",
    authKey: token,
    userId: userId
  });

  if (pubNub) {
    addSubscriptions(pubNub, user, setPresenceData, store);
    addUserListeners(pubNub, user, store);
  }
}

function callPubNubToken(store) {
  const accessToken = getAccessTokenFromState(store.getState());
  const wowHeaders = wowCustomHeader(store.getState());

  fetch(apiUrls.GET_TOKEN_URL, {
    method: 'GET',
    body: null,
    responseType: 'json',
    crossDomain: true,
    timeout: apiUrls.API_TIMEOUT,
    headers: {
      ...wowHeaders,
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + accessToken,
      'Accept': 'application/json'
    }
  }).then((resp) => {
    if (!resp.ok) {
      console.error(`[PubNub] Token fetch failed: ${resp.status} ${resp.statusText} — ${apiUrls.GET_TOKEN_URL}`);
      return Promise.reject(new Error(`Token fetch ${resp.status}`));
    }
    return resp.json();
  })
    .then((data) => {
      store.dispatch(statusActions.setPubNubToken(data));
    })
    .catch((err) => {
      console.error('[PubNub] callPubNubToken error:', err);
    });
}

export const addSubscriptions = (pubNub, user, presenceCallback, store) => {
  const primaryMarket = user.get("primaryMarket");
  const auxiliaryMarket = user.get("auxiliaryMarket");
  const channels = [user.get("userId"), "field_everyone"];

  if (primaryMarket) {
    channels.push(primaryMarket);
  }

  if (auxiliaryMarket) {
    channels.push(auxiliaryMarket);
  }

  pubNub.subscribe({
    channels: channels,
    restore: true,
    presence: data => {
      presenceCallback(store, data);
    }
  });

  pubNub.hereNow(
    {
      channels: channels,
      includeState: true
    },
    (status, response) => {
      store.dispatch(userActions.setChannelData(response));
    }
  );
};

export const addUserListeners = (pubNub, user, store) => {
  pubNub.removeAllListeners();

  pubNub.addListener({
    message: message => userChannelListener(message, user, store),
    status: statusEvent => statusListener(statusEvent, user, store)
  });
};

function middlewareHandler(store, next, action) {
  next(action);
  const state = store.getState();
  const user = state.getIn(['user']);
  const userId = user.get('userId');
  const techId = state.getIn(['techData', 'techs', userId, 'info', 'techId']);

  if (action.type === "USER_CHANNEL_GRANT_APPIAN_FINISHED") {
    logger.info("User channel grant appian finished.");

    if (!appianPubNub) {
      initAppianPubnub(techId, user, store);
    } else {
      appianPubNub.removeAllListeners();
      initAppianPubnub(techId, user, store);
    }
  }

  if (action.type === "OUTLET_UPDATE_STARTED") {

    const accessToken = getAccessTokenFromState(state);

    const technicianId = state
      .getIn([
        "workOrder",
        "workOrderDetails",
        action.orderId,
        "schedulingSystemDetails",
        "details"
      ])
      .get("technicianId");

    store.dispatch(
      messageActions.userChannelGrantAppianStarted(
        accessToken,
        technicianId
      )
    );
  }

  if (action.type === "USER_CHANNEL_GRANT_FINISHED") {
    logger.info("User channel grant finished.");

    if (pubNub) {
      logger.info(
        "Pubnub instance already created, setting auth key and reconnecting."
      );
      callPubNubToken(store);
      let pubNubToken = state.getIn(["techData", "pubNubToken"]);
      if (pubNubToken) { pubNub.setToken(pubNubToken); }
      pubNub.reconnect();
    } else {
      logger.info("Calling initPubNub after user channel grant finished.");
      initPubNub(user, techId, store);
    }
  }

  if (action.type === "redux-oidc/SESSION_TERMINATED") {
    if (pubNub) {
      pubNub.stop();
    }
    if (appianPubNub) {
      appianPubNub.stop();
    }
  }

  if (action.type === "PUBLISH_MESSAGE" && pubNub) {
    pubNub.publish({
      message: action.message,
      sendByPost: true,
      channel: action.channel
    });
  }

  if (action.type === "SET_PUBNUB_TOKEN") {
    addSubAndListen(action.token, user, store);
  }

  if (action.type.includes("TECH_STATUS")) {
    if (pubNub) {
      let pubNubToken = state.getIn(["techData", "pubNubToken"]);
      if (pubNubToken) {
        const tokenData = pubNub.parseToken(pubNubToken);
        if (tokenData &&
          typeof tokenData.timestamp === "number" &&
          typeof tokenData.ttl === "number") {
          if (new Date().getTime() > (tokenData.timestamp + (tokenData.ttl * 60)) * 1000) {
            toastr.warning(
              'Tech Status token expired.',
              'Reconnecting to the server',
              {
                timeOut: 10 * 1000,
              }
            );
            callPubNubToken(store);
          }
        }
      }
      else {
        console.log(`Token not found. Initializing PubNub.`);
        initPubNub(user, techId, store);
      }
    }
    else {
      console.log(`PubNub not found. Initializing...`);
      initPubNub(user, techId, store);
    }
  }

  if (!monitoringInterval) {
    monitoringInterval = setInterval(() => {
      if (!pubNub) {
        logger.info(
          "Pubnub not found during monitoring interval, calling initPubNub."
        );
        initPubNub(user, techId, store);
      }
    }, 5000);
  }
}
export default store => next => action => {
  middlewareHandler(store, next, action);
};



// WEBPACK FOOTER //
// ./src/store/pubnubMiddleware.js